<template>
  <vx-card class="org-card w-full">
    <div class="flex items-start">
      <span
        class="template-options-btn-icon p-4 inline-flex feather-icon text-primary mr-3"
        :style="{ background: appDetails.color, 'border-radius': '10px' }"
      >
        <img :src="appDetails.icon" width="28px" height="28px" />
      </span>
      <div class="relative m-1">
        <h4 class="mb-1">{{ appDetails.title }}</h4>
        <p>{{ appDetails.shortDescription }}</p>
      </div>
    </div>
    <vs-divider />
    <div>
      <p v-html="appDetails.description"></p>
    </div>
    <vs-divider />
    <div v-if="appDetails.ss1">
      <img :src="appDetails.ss1" width="50%" />
    </div>
  </vx-card>
</template>

<script>
import marketplaceList from "@/assets/data/marketplace-list.js";

export default {
  data() {
    return {
      marketplaceList,
      appDetails: {},
    };
  },
  computed: {
    marketplaceAppId() {
      return this.$route.params.marketplaceAppId;
    },
  },
  created() {
    this.marketplaceList.forEach((app) => {
      if (this.marketplaceAppId === app.id) {
        this.appDetails = app;
      }
    });
  },
};
</script>

<style scoped></style>
